/**
 * Clear app-specific authentication cookies
 * NOTE: HTTP-only cookies (like AWSELBAuthSessionCookie-*) cannot be cleared from JavaScript
 * and require server-side clearing or logout redirect
 */
export const clearAllCookies = (): void => {
  const hostname = window.location.hostname;
  const cookies = document.cookie.split(';').map(c => c.trim().split('=')[0]).filter(Boolean);

  cookies.forEach(name => {
    document.cookie = `${name}=;expires=Thu, 01 Jan 1970 00:00:00 GMT;path=/;domain=${hostname};Secure;SameSite=None`;
    document.cookie = `${name}=;expires=Thu, 01 Jan 1970 00:00:00 GMT;path=/;Secure;SameSite=None`;
  });
};
